import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Segment, Grid, Header, Icon, Button } from 'semantic-ui-react'
import AppInboxRow from './components/row'

import AppInboxActions from '../../reducers/appInboxReducer'

class AppInbox extends Component {
  componentWillMount() {
    const { unSyncAppInboxes } = this.props
    unSyncAppInboxes()
  }

  componentDidMount() {
    const { syncAppInboxes } = this.props
    syncAppInboxes()
  }

  onEditClick = (appInbox) => {
    const { history } = this.props

    history.push({
      pathname: `/app-inbox/${appInbox.id}/edit`,
      state: { appInboxData: appInbox },
    })
  }

  onDeleteClick = appInbox => {
    const { deleteAppInbox } = this.props
    const confirm = window.confirm(`Are you sure to delete this Inbox? \nTitle: ${appInbox.title.en}`)

    if (confirm) {
      deleteAppInbox(appInbox.id)
    }
  }

  render() {
    const { appInboxes } = this.props

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Header size="large" style={{ display: 'inline-block' }}>
                In-App Inbox
              </Header>
              <Link to="/app-inbox/new" style={{ float: 'right' }}>
                <Button icon color="black">
                  <Icon name="add" />
                </Button>
              </Link>
              {
                _.map(appInboxes, (appInbox, key) => (
                  <AppInboxRow
                    key={key}
                    data={appInbox}
                    onEdit={() => this.onEditClick(appInbox)}
                    onDelete={() => this.onDeleteClick(appInbox)}
                  />
                ))
              }
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ appInboxes }) => ({
  appInboxes: appInboxes.data
})

const mapDispatch = {
  deleteAppInbox: AppInboxActions.deleteAppInbox,
  syncAppInboxes: AppInboxActions.syncAppInboxes,
  unSyncAppInboxes: AppInboxActions.unSyncAppInboxes,
}

export default connect(mapState, mapDispatch)(AppInbox)



// WEBPACK FOOTER //
// ./src/containers/appInbox/index.js